(function () {
  let observerInstance = null;
  let mutationObserver = null;
  let currentGrid = null;

  function setup() {
    const productGrid = document.querySelector('#product-grid');
    const paginationWrapper = document.querySelector('.pagination');

    if (!productGrid || !paginationWrapper) return;

    // Agar same grid pe already setup hai, sirf pagination fir se hide karo
    if (productGrid === currentGrid && paginationWrapper.dataset.prashaInit === '1') {
      paginationWrapper.style.display = 'none';
      return;
    }

    currentGrid = productGrid;

    function getNextUrl() {
      const nextLink = paginationWrapper.querySelector('a[aria-label="Next page"]');
      return nextLink ? nextLink.href : null;
    }

    let nextUrl = getNextUrl();
    let loading = false;

    paginationWrapper.dataset.prashaInit = '1';
    paginationWrapper.style.display = 'none';

    // Purana loader/sentinel hata do (naya grid aaya hai to)
    document.querySelectorAll('.prasha-loader, .prasha-sentinel').forEach(el => el.remove());

    if (!nextUrl) return;

    const loader = document.createElement('div');
    loader.className = 'prasha-loader';
    loader.innerHTML = '<span class="prasha-loader__dot"></span><span class="prasha-loader__dot"></span><span class="prasha-loader__dot"></span>';
    loader.style.display = 'none';
    productGrid.insertAdjacentElement('afterend', loader);

    const sentinel = document.createElement('div');
    sentinel.className = 'prasha-sentinel';
    sentinel.style.height = '1px';
    loader.insertAdjacentElement('afterend', sentinel);

    async function loadMore() {
      if (!nextUrl || loading) return;
      loading = true;
      loader.style.display = 'flex';

      try {
        const res = await fetch(nextUrl);
        const text = await res.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');

        const newProducts = doc.querySelectorAll('#product-grid .grid__item');
        const newPagination = doc.querySelector('.pagination');

        newProducts.forEach((item, i) => {
          item.style.opacity = '0';
          item.style.transform = 'translateY(16px)';
          productGrid.appendChild(item);
          setTimeout(() => {
            item.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
            item.style.opacity = '1';
            item.style.transform = 'translateY(0)';
          }, i * 30);
        });

        if (newPagination) {
          paginationWrapper.innerHTML = newPagination.innerHTML;
          paginationWrapper.style.display = 'none';
          nextUrl = getNextUrl();
        } else {
          nextUrl = null;
        }

      } catch (err) {
        console.error('Infinite scroll error:', err);
        loading = false;
        loader.style.display = 'none';
        return;
      }

      loading = false;
      loader.style.display = 'none';

      const rect = sentinel.getBoundingClientRect();
      if (rect.top < window.innerHeight + 800 && nextUrl) {
        loadMore();
      }
    }

    if (observerInstance) observerInstance.disconnect();

    observerInstance = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && !loading && nextUrl) {
        loadMore();
      }
    }, {
      root: null,
      rootMargin: '0px 0px 800px 0px',
      threshold: 0
    });

    observerInstance.observe(sentinel);

    const rect = sentinel.getBoundingClientRect();
    if (rect.top < window.innerHeight + 800 && nextUrl) {
      loadMore();
    }
  }

  function init() {
  setup();

  // Pehle: '#product-grid-container' ya '.collection' pe observe kar rahe the
  // Problem: filter apply hone par ye poora node hi replace ho jata hai,
  // isliye observer purane (detached) node ko dekhta reh jata hai.
  //
  // Fix: hamesha stable parent (main ya body) pe observe karo,
  // taaki grid/pagination chahe kitni baar bhi poora replace ho, observer catch kar le.
  const target = document.querySelector('main') || document.body;

  if (mutationObserver) mutationObserver.disconnect();

  mutationObserver = new MutationObserver(() => {
    clearTimeout(mutationObserver._t);
    mutationObserver._t = setTimeout(setup, 150);
  });

  mutationObserver.observe(target, { childList: true, subtree: true });
}

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(init, 800));
  } else {
    setTimeout(init, 800);
  }
})();